import {h} from 'preact';
import {useEffect, useCallback, useState, useRef} from 'preact/hooks';

import Choices from 'choices.js';

/** HELPER **/
const merge = (delimiter, ...strings) => strings.filter(i => i).join(delimiter);

const getSchoolLabel = ({name, streetAddress, postalCode, addressLocality}) =>
    merge(', ', name, streetAddress, merge(', ', postalCode, addressLocality));

const MANUAL_SCHOOL_INPUT = 'MANUAL_SCHOOL_INPUT';

/** EXPORT **/
export default ({name, selectedSchool, schools, updateSchool, onManualInput}) => {
    const input = useRef(null);

    const onSchoolSelect = e => {
        const selectedShoolIdentifier = e.detail.choice.value;

        if (selectedShoolIdentifier === MANUAL_SCHOOL_INPUT) {
            onManualInput();
        } else {
            const selectedSchool = schools.find(({identifier}) => selectedShoolIdentifier === identifier)

            if (selectedSchool) {
                updateSchool(selectedSchool);
            }
        }
    };

    useEffect(() => {
        try {
            new Choices(input.current, {
                removeItemButton: true,
                searchEnabled: false,
                shouldSort: false,
                noChoicesText: 'Keine weiteren Optionen vorhanden.'
            });

            input.current.addEventListener('choice', onSchoolSelect);
        } catch(e) {}
    }, [schools]);

    const hasSelectedSchool = Object.keys(selectedSchool).length > 0;

    return (
        <div className={["formField", "formField--textInput", "schoolSelect", !hasSelectedSchool && "schoolSelect--required"].filter(i => i).join(' ')}>
            <i className="fa fa-bold fa-2x fa-angle-down formField__selectIcon"></i>
            <select name={name} ref={input}>
                <option placeholder disabled selected={!hasSelectedSchool}>Schule auswählen *</option>
                <option key="MANUAL" value={MANUAL_SCHOOL_INPUT}>…meine Schule ist nicht dabei - manuelle Eingabe…</option>
                {
                    schools.map(school => (
                        <option
                            selected={selectedSchool.identifier === school.identifier}
                            key={school.identifier}
                            value={school.identifier}
                        >
                            {getSchoolLabel(school)}
                        </option>
                    ))
                }
            </select>
            <label for="school" className="label_noTransition">
                Schule auswählen *
            </label>
        </div>
    );
}
